<h1>
  <app-tlumacz [id]="'Podziękowanie'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz>
</h1>
<h2>

  <app-tlumacz [id]="'Wroć_do_produkcyjnego'" [typ]="'stale'" [tresci]="tresci"></app-tlumacz>
</h2>
